import { BriefcaseIcon, BookOpen, GlobeIcon, GraduationCap } from "lucide-react";

const Features = () => {
  const features = [
    {
      icon: <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600"><BriefcaseIcon className="w-6 h-6" /></div>,
      title: "Visa Sponsored Jobs",
      description: "Access thousands of pre-screened jobs with visa sponsorship from verified employers worldwide.",
      color: "bg-yellow-50"
    },
    {
      icon: <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600"><BookOpen className="w-6 h-6" /></div>,
      title: "Visa & Passport Information",
      description: "Access comprehensive, up-to-date information and expert guidance for obtaining visas and passports for 190+ countries.",
      color: "bg-blue-50"
    },
    {
      icon: <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600"><GlobeIcon className="w-6 h-6" /></div>,
      title: "Over 100 Visa Travel Guides",
      description: "Access detailed guides for 190+ countries with visa and cost of living information.",
      color: "bg-green-50"
    },
    {
      icon: <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600"><GraduationCap className="w-6 h-6" /></div>,
      title: "University Admissions",
      description: "Navigate applications for top global universities with step-by-step guidance.",
      color: "bg-purple-50"
    },
  ];

  return (
    <section id="features" className="py-16">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-3">Everything you need for global mobility.</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className={`rounded-2xl p-6 ${feature.color} flex flex-col h-full`}>
              <div className="mb-4">
                {feature.icon}
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 flex flex-col lg:flex-row gap-8 items-center">
          <div className="w-full lg:w-1/2">
            <img 
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f" 
              alt="Person celebrating success" 
              className="w-full h-auto rounded-2xl"
            />
          </div>
          
          <div className="w-full lg:w-1/2 space-y-6">
            <h2 className="text-3xl font-bold">Why use Visa Now?</h2>
            <p className="text-gray-600">
              Visa Now streamlines your entire international journey, from finding visa-sponsored employment to preparing for language exams and university applications. We provide all the tools you need in one place.
            </p>
            
            <div className="space-y-4">
              {['Automated job applications', 'Personalized study plans', 'Travel checklist management'].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-black flex items-center justify-center">
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>{item}</span>
                </div>
              ))}
            </div>
            
            <button className="bg-black text-white px-6 py-3 rounded-md font-medium mt-2">
              Get started
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
